<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import { ProductPerPageEntity } from "@shared/services/event_tracking/entities";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import {
    DEFAULT_LIMIT,
    PRODUCT_LISTING_LIMITS,
    ProductLineListingStore,
    updateProductLineListingStore,
  } from "@retailer/svelte/ProductLines/ProductLineContainer/stores/ProductLineListingStore";

  const { trackClick } = EventTracking;

  export let refreshState;
  export let stateParams;

  export let mobileMode;
  export let page: number = 1;
  export let total: number = 0;

  const options = PRODUCT_LISTING_LIMITS;

  $: perPage = $ProductLineListingStore.productListLimit;

  const onChange = e => {
    const res = e.target.value;
    applyChange(res);
  };

  const applyChange = change => {
    let limit = change === "" ? DEFAULT_LIMIT : +change;
    updateProductLineListingStore(s => {
      s.productListLimit = limit;
      return s;
    });
    trackClick(null, new ProductPerPageEntity({ value: limit }));
    let maxPage = Math.ceil(total / limit);
    const newStateParams = { ...stateParams, limit: limit, page: page > maxPage ? maxPage : page };
    perPagePanelOpened = false;
    refreshState(newStateParams);
  };

  const updateSelection = newSelection => {
    perPage = newSelection;
  };

  const onSeeResults = () => {
    if (perPage != stateParams.limit) {
      applyChange(perPage);
    }
  };

  let perPagePanelOpened: boolean;
  const openPerPagePanel = () => {
    perPagePanelOpened = true;
  };

  const closePerPagePanel = () => {
    perPagePanelOpened = false;
  };

</script>

{#if mobileMode}
  <button
    on:click={openPerPagePanel}
    class="fizz-button fizz-full-width"
    id="mobile-limit-button"
    data-testid="mobile-limit-button"
    style="margin-right: 0;"
  >
    <div class="fizz-flex-row-8 fizz-justify-center">
      <span class="fizz-text-regular">Show: </span>
      <span class="fizz-text-strong">{perPage}</span>
      <Icon type="ArrowDown" width="8" height="8" />
    </div>
  </button>

  <div class="fizz-has-panel" class:fizz-panel-is-open={perPagePanelOpened}>
    <div
      class="fizz-panel"
      style="--panel-width: 100%; height: 100%; position: fixed; z-index: 20000;"
    >
      <div class="fizz-border-top fizz-border-bottom fizz-inset-square-16">
        <div class="fizz-flex-row fizz-space-between">
          <span class="fizz-heading-4">Show</span>
          <button data-testid="close-limit-select" on:click={closePerPagePanel}>
            <Icon width="16" height="16" type="X" />
          </button>
        </div>
      </div>
      <div class="fizz-inset-square-16" style="height: 70vh;" id="mobile-product-limit-select">
        <ul class="fizz-flow-4">
          {#each options as option}
            <li>
              <label class="fizz-flex-row-8">
                <input
                  data-testid="limit-button-{option}"
                  type="radio"
                  class="fizz-radio-button"
                  value={option}
                  checked={option == perPage}
                  on:change={() => updateSelection(option)}
                />
                <span>{option} {typeof option}</span>
              </label>
            </li>
          {/each}
        </ul>
      </div>
      <div class="fizz-border-top fizz-inset-square-16">
        <button
          data-testid="apply-limit"
          type="button"
          class="fizz-button-secondary fizz-full-width"
          on:click={onSeeResults}
        >
          See results
        </button>
      </div>
    </div>
  </div>
{:else}
  <div class="fizz-select--limit">
    <select
      class="fizz-select fizz-full-width"
      name="product_limit"
      id="product-limit-select"
      data-testid="product-limit-select"
      on:change={onChange}
      value={perPage}
    >
      {#each options as option}
        <option value={option}>{option}</option>
      {/each}
    </select>
  </div>
{/if}
